/**
 * 首页配置文件
 * 支持多语言切换
 */
import { deepCloneConfig } from '@/utils/deepCloneConfig'
import { applyPortalZhToRu } from '@/utils/applyPortalZhToRu'
import { getCurrentLocale } from '@/utils/i18nText'
import { withNavModuleIcons } from '@/config/navModuleIcons'
import { L, resolveLocaleImages } from '@/utils/localeAsset'

// 中文配置
const zhCN = {
  // 网站信息
  siteInfo: {
    title: '杨凌农业科技成果转化综合信息服务平台',
    logo: L('shouye/web-logo.png'),
    loginText: '登录',
    registerText: '注册',
    logoutText: '退出'
  },
  
  // 头部信息
  header: {
    title: '中国杨凌农创汇',
    subtitle: '全国农业科技大市场暨农业世界分中心',
    backgroundImage: L('shouye/head-bg.png'),
    titleImage: L('shouye/head-title.png'),
    searchPlaceholder: '请输入关键字进行检索',
    searchButton: '搜索'
  },
  
  // 热门搜索
  hotSearch: {
    title: '热门搜索：',
    keywords: ['牛干草种植', '饲料', '灌溉技术', '土壤水肥'],
    historySearch: '历史搜索',
    clearHistory: '清除记录'
  },
  
  // 快捷链接
  quickLinks: {
    lawRegulations: '法规解读',
    hotRecommend: '清单资源'
  },
  
  // 功能模块
  modules: [
    {
      id: 'home',
      name: '首页',
      enName: 'HOME',
      icon: L('shouye/home.png'),
      link: '/index'
    },
    {
      id: 'innovation',
      name: '走进杨凌',
      enName: 'YANGLING',
      icon: L('shouye/chuangxinyangling.png'),
      link: '/innovation'
    },
    {
      id: 'supply',
      name: '供需中心',
      enName: 'SUPPLY & DEMAND',
      icon: L('shouye/gongxuzhongxin.png'),
      link: '/supply'
    },
    {
      id: 'evaluation',
      name: '价值评估',
      enName: 'EVALUATE',
      icon: L('shouye/jiazhipinggu.png'),
      link: '/evaluation'
    },
    {
      id: 'manager',
      name: '技术经理人',
      enName: 'MANAGER',
      icon: L('shouye/jishujingliren.png'),
      link: '/manager'
    },
    {
      id: 'transaction',
      name: '交易中心',
      enName: 'TRANSACTION',
      icon: L('shouye/jiaoyizhongxin.png'),
      link: '/transaction'
    },
    {
      id: 'service',
      name: '科创服务',
      enName: 'SERVICE',
      icon: L('shouye/kechuangfuwu.png'),
      link: '/innovation-service'
    },
    {
      id: 'talent',
      name: '科技人才',
      enName: 'TALENT',
      icon: L('shouye/kejirencai.png'),
      link: '/talent'
    },
    {
      id: 'enterprise',
      name: '农业企业',
      enName: 'ENTERPRISE',
      icon: L('shouye/nongyeqiye.png'),
      link: '/agriculture-enterprise'
    },
    {
      id: 'policy',
      name: '政策信息',
      enName: 'POLICY',
      icon: L('shouye/zhengcexinxi.png'),
      link: '/policy'
    }
  ],
  
  // 科技动态
  techTrends: {
    title: '科技动态',
    subTitle: 'TECHNOLOGY TRENDS',
    tabs: [
      { label: '新闻中心', value: 'news' },
      { label: '通知公告', value: 'notice' },
      { label: '路演与直播', value: 'roadshow' }
    ],
    moreText: '更多+'
  },
  
  // 政策信息
  policyInfo: {
    title: '政策信息',
    subTitle: 'POLICY INFORMATION',
    tabs: [
      { label: '科技政策', value: 'tech' },
      { label: '政策解读', value: 'interpret' }
    ],
    moreText: '更多+'
  },
  
  // 发布需求
  publishDemand: {
    backgroundImage: L('shouye/fabu-bg.png'),
    buttonImage: L('shouye/woyaofabu.png'),
    itemBackground: L('shouye/fabu-item-bg.png'),
    publishedTitle: '发布成果',
    pendingTitle: '发布需求',
    unit: '条',
    subtitle: '汇聚创新之光 · 匹配供需之桥',
    buttonText: '我要发布'
  },
  
  // 新闻详情页
  newsDetail: {
    breadcrumb: {
      home: '首页',
      current: '新闻详情'
    },
    defaultTitle: '未设置标题',
    defaultContent: '暂无内容',
    exampleTitle: '新闻标题示例'
  },
  
  // 页脚信息
  footer: {
    copyright: '',
    support: '技术支持：浪潮软件科技有限公司'
  }
}

// 英文配置（预留）
const enUS = {
  siteInfo: {
    title: 'Yangling Agriculture Technology Achievements Transformation Comprehensive Information Platform',
    logo: L('shouye/web-logo.png'),
    loginText: 'Login',
    registerText: 'Register',
    logoutText: 'Logout'
  },
  header: {
    title: 'China Yangling Agri-Innovation Hub',
    subtitle: 'National Agricultural S&T Marketplace and World Sub-center',
    backgroundImage: L('shouye/head-bg.png'),
    titleImage: L('shouye/head-title.png'),
    searchPlaceholder: 'Enter keywords to search',
    searchButton: 'Search'
  },
  hotSearch: {
    title: 'Hot searches: ',
    keywords: ['hay planting', 'feed', 'irrigation technology', 'soil water & fertilizer'],
    historySearch: 'Search history',
    clearHistory: 'Clear'
  },
  quickLinks: {
    lawRegulations: 'Policy & Regulations',
    hotRecommend: 'Resource List'
  },
  modules: [
    { id: 'home', name: 'Home', enName: 'HOME', icon: L('shouye/home.png'), link: '/index' },
    { id: 'innovation', name: 'Innovation Yangling', enName: 'YANGLING', icon: L('shouye/chuangxinyangling.png'), link: '/innovation' },
    { id: 'supply', name: 'Supply & Demand', enName: 'SUPPLY & DEMAND', icon: L('shouye/gongxuzhongxin.png'), link: '/supply' },
    { id: 'evaluation', name: 'Value Assessment', enName: 'EVALUATE', icon: L('shouye/jiazhipinggu.png'), link: '/evaluation' },
    { id: 'manager', name: 'Tech Managers', enName: 'MANAGER', icon: L('shouye/jishujingliren.png'), link: '/manager' },
    { id: 'transaction', name: 'Transaction Center', enName: 'TRANSACTION', icon: L('shouye/jiaoyizhongxin.png'), link: '/transaction' },
    { id: 'service', name: 'Innovation Services', enName: 'SERVICE', icon: L('shouye/kechuangfuwu.png'), link: '/innovation-service' },
    { id: 'talent', name: 'Tech Talent', enName: 'TALENT', icon: L('shouye/kejirencai.png'), link: '/talent' },
    { id: 'enterprise', name: 'Agricultural Enterprises', enName: 'ENTERPRISE', icon: L('shouye/nongyeqiye.png'), link: '/agriculture-enterprise' },
    { id: 'policy', name: 'Policy', enName: 'POLICY', icon: L('shouye/zhengcexinxi.png'), link: '/policy' }
  ],
  techTrends: {
    title: 'Science and Technology Trends',
    subTitle: 'TECHNOLOGY TRENDS',
    tabs: [
      { label: 'News', value: 'news' },
      { label: 'Notices', value: 'notice' },
      { label: 'Roadshow & Live', value: 'roadshow' }
    ],
    moreText: 'More+'
  },
  policyInfo: {
    title: 'Policy Information',
    subTitle: 'POLICY INFORMATION',
    tabs: [
      { label: 'S&T Policy', value: 'tech' },
      { label: 'Interpretation', value: 'interpret' }
    ],
    moreText: 'More+'
  },
  publishDemand: {
    backgroundImage: L('shouye/fabu-bg.png'),
    buttonImage: L('shouye/woyaofabu.png'),
    itemBackground: L('shouye/fabu-item-bg.png'),
    publishedTitle: 'Published Achievements',
    pendingTitle: 'Published Demands',
    unit: 'items',
    subtitle: 'Gather innovation · Bridge supply and demand',
    buttonText: 'Publish'
  },
  newsDetail: {
    breadcrumb: {
      home: 'Home',
      current: 'News Detail'
    },
    defaultTitle: 'No Title',
    defaultContent: 'No Content',
    exampleTitle: 'News Title Example'
  },
  footer: {
    copyright: '',
    support: 'Technical Support: Inspur Software Technology Co., Ltd.'
  }
}

const ruRU = applyPortalZhToRu(deepCloneConfig(zhCN))

/** 导航暂未开放的模块 id（先隐藏） */
const HIDDEN_NAV_MODULE_IDS = ['policy']

/** 过滤导航模块列表 */
export function filterNavModules(modules = [], locale = getCurrentLocale()) {
  if (!Array.isArray(modules)) return []
  const visible = modules.filter(item => item && !HIDDEN_NAV_MODULE_IDS.includes(item.id))
  return withNavModuleIcons(visible, locale)
}

// 当前语言配置
let currentLang = 'zh-CN'

// 语言配置映射
const langMap = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'ru-RU': ruRU
}

// 获取配置
export function getHomeConfig(lang) {
  const locale = lang || currentLang
  const config = langMap[locale] || zhCN
  return resolveLocaleImages(config, locale)
}

// 设置语言
export function setLanguage(lang) {
  if (langMap[lang]) {
    currentLang = lang
  }
}

// 获取当前语言
export function getCurrentLanguage() {
  return currentLang
}

export default {
  getHomeConfig,
  setLanguage,
  getCurrentLanguage,
  filterNavModules
}
